export default {
  address: ['user-input', 'map', 'informer', 'common/cottage-village-name'],
  'about-land': ['common/area-land', 'land-category', 'common/suburban-building-status-land'],
  facilities: ['common/has-electricity', 'common/gas', 'common/drainage', 'common/water'],
  'price-and-deal-terms': ['price-sale', 'agent-bonus'],
};
